module.exports = __webpack_public_path__ + "static/media/flossyfresh-logo.6486133d.jpg";